import { Column } from "devextreme-react/data-grid"
import React from "react"
import { Row } from "../layout/grid/Row"

interface ColumnActionsProps {
    width?: number
    caption?: string
    fixed?: boolean
    fixedPosition?: "left" | "right"
    children: (cellInfo: any) => React.ReactNode
}

export const ColumnActions: React.FC<ColumnActionsProps> = ({
    width = 100,
    caption = "Actions",
    fixed = true,
    fixedPosition = "right",
    children,
}) => {
    return (
        <Column
            width={width}
            caption={caption}
            fixed={fixed}
            fixedPosition={fixedPosition}
            alignment="right"
            cellRender={(cellInfo) =>
                <Row>
                    <Row.End>
                        {children(cellInfo)}
                    </Row.End>
                </Row>
            }
        />
    )
}
